import { Box, Card, Divider, Typography } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import { BookingDetailsContext } from './Viewdetails'
import { set } from 'zod';

const PaymentDescription = () => {
   const {bookingDetailsdata} = useContext(BookingDetailsContext);
   const [descriptionData, setDescriptionData] = useState({
    collectableAmount: '',
    serviceSubtotal:'',
    visitingCharges:'',
    totalDiscounts:'',
    taxableAmount:'',
    tcsAmount:'',
    totalExpertEarning:'',
    platformFee:'',
    convenienceFee:'',
    totalTax:'',
    cudelBalance:''
   })
   useEffect(()=>{
    if(bookingDetailsdata){
        let collectableAmount = parseFloat(bookingDetailsdata?.total).toFixed(2) || 0.00;
        let serviceSubtotal = parseFloat(bookingDetailsdata?.subTotal).toFixed(2) || 0.00;
        let visitingCharges = parseFloat(bookingDetailsdata?.visitingCharge).toFixed(2) || 0.00;
        let totalDiscounts = parseFloat(parseFloat(bookingDetailsdata?.discount) + parseFloat(bookingDetailsdata?.couponAmount) + parseFloat(bookingDetailsdata?.coinValue)).toFixed(2);
        let taxableAmount = parseFloat(parseFloat(serviceSubtotal) + parseFloat(visitingCharges) - totalDiscounts).toFixed(2);
        let tcsAmount = parseFloat(taxableAmount * 0.01).toFixed(2) || 0.00;
        let totalExpertEarning = parseFloat(parseFloat(serviceSubtotal)+parseFloat(visitingCharges)-totalDiscounts-tcsAmount).toFixed(2) || 0.00;
        let platformFee = parseFloat(bookingDetailsdata?.platformCharges).toFixed(2) || 0.00;
        let convenienceFee = parseFloat(bookingDetailsdata?.convenienceFee).toFixed(2) || 0.00;
        let totalTax = parseFloat(bookingDetailsdata?.tax).toFixed(2) || 0.00;
        let cudelBalance = parseFloat(parseFloat(platformFee)+parseFloat(convenienceFee)+parseFloat(totalTax)+parseFloat(tcsAmount)).toFixed(2) || 0.00;

        setDescriptionData({
            collectableAmount,
            serviceSubtotal,
            visitingCharges,    
            totalDiscounts,
            taxableAmount,
            tcsAmount,
            totalExpertEarning,
            platformFee,
            convenienceFee,
            totalTax,
            cudelBalance
        })
    }
   },[bookingDetailsdata])
  return (
    <Box sx={{bgcolor:'#F5F5F5',p:'2%'}}>
        <Card>
            <Box sx={{p:'1% 2%',display:'flex',justifyContent:'space-between',alignItems:'center',borderBottom:'1px solid lightGray'}}>
                <Typography sx={{fontSize:'0.85rem',fontWeight:600,color:'#181818'}}>Customer Payment Summary</Typography>
                <Typography sx={{fontSize:'0.65rem',fontWeight:600,color:'#1A44B8'}}>{bookingDetailsdata?.payment?.paymentMethod}</Typography>
            </Box>
            <Box sx={{p:'1% 2%',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                <Typography sx={{fontSize:'0.75rem',fontWeight:600,color:'#EE9B1A'}}>Collectable Amount</Typography>
                <Typography sx={{fontSize:'0.75rem',fontWeight:500,color:'#EE9B1A'}}>₹ {descriptionData?.collectableAmount}</Typography>
            </Box>
        </Card>
        <Card sx={{my:'2%'}}>
            <Box sx={{p:'1% 2%',display:'flex',justifyContent:'space-between',alignItems:'center',borderBottom:'1px solid lightGray'}}>
                <Typography sx={{fontSize:'0.85rem',fontWeight:600,color:'#181818'}}>Expert's Earning</Typography>
                {/* <Typography sx={{fontSize:'0.65rem',fontWeight:600,color:'#1A44B8'}}>Customer Payment</Typography> */}
            </Box>
            <Box sx={{p:'1% 2%',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                <Typography sx={{fontSize:'0.75rem',fontWeight:600,color:'#181818'}}>Service Subtotal</Typography>
                <Typography sx={{fontSize:'0.75rem',fontWeight:500,color:'#181818'}}>₹ {descriptionData?.serviceSubtotal}</Typography>
            </Box>
            <Box sx={{p:'1% 2%',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                <Typography sx={{fontSize:'0.75rem',fontWeight:600,color:'#181818'}}>Visiting Charges</Typography>
                <Typography sx={{fontSize:'0.75rem',fontWeight:500,color:'#181818'}}>₹ {descriptionData?.visitingCharges}</Typography>
            </Box><Box sx={{p:'1% 2%',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                <Typography sx={{fontSize:'0.75rem',fontWeight:600,color:'#d32f2f'}}>Discounts Applied</Typography>
                <Typography sx={{fontSize:'0.75rem',fontWeight:500,color:'#d32f2f'}}>
                    -₹ {descriptionData?.totalDiscounts}
                    
                </Typography>
            </Box>
            <Divider 
                variant="middle" // optional: for inset margins
                sx={{ 
                    borderStyle: 'dashed',
                    borderColor: 'lightgray' 
                }}
            />
            <Box sx={{p:'1% 2%',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                <Typography sx={{fontSize:'0.75rem',fontWeight:600,color:'#181818'}}>Taxable Amount</Typography>
                <Typography sx={{fontSize:'0.75rem',fontWeight:500,color:'#181818'}}>₹ {descriptionData?.taxableAmount || '0.00'}</Typography>
            </Box>
            <Box sx={{p:'1% 2%',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                <Typography sx={{fontSize:'0.75rem',fontWeight:600,color:'#d32f2f'}}>TCS (1% of Taxable Amount)</Typography>
                <Typography sx={{fontSize:'0.75rem',fontWeight:500,color:'#d32f2f'}}>-₹ {descriptionData?.tcsAmount || `0.00`}</Typography>
            </Box>
            <Box sx={{p:'1% 2%',display:'flex',justifyContent:'space-between',alignItems:'center',borderTop:'1px solid lightGray'}}>
                <Typography sx={{fontSize:'0.85rem',fontWeight:600,color:'#40B962'}}>Total Earnings </Typography>
                <Typography sx={{fontSize:'0.65rem',fontWeight:600,color:'#40B962'}}>₹ {descriptionData?.totalExpertEarning || '0.00'}</Typography>
            </Box>
        </Card>
        <Card>
            <Box sx={{p:'1% 2%',display:'flex',justifyContent:'space-between',alignItems:'center',borderBottom:'1px solid lightGray'}}>
                <Typography sx={{fontSize:'0.85rem',fontWeight:600,color:'#181818'}}>CuDel Balance </Typography>
                {/* <Typography sx={{fontSize:'0.65rem',fontWeight:600,color:'#1A44B8'}}>Customer Payment</Typography> */}
            </Box>
            <Box sx={{p:'1% 2%',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                <Typography sx={{fontSize:'0.75rem',fontWeight:600,color:'#181818'}}>Platform Fee</Typography>
                <Typography sx={{fontSize:'0.75rem',fontWeight:500,color:'#181818'}}>₹ {descriptionData?.platformFee}</Typography>
            </Box>
            <Box sx={{p:'1% 2%',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                <Typography sx={{fontSize:'0.75rem',fontWeight:600,color:'#181818'}}>Convenience Fee</Typography>
                <Typography sx={{fontSize:'0.75rem',fontWeight:500,color:'#181818'}}>₹ {descriptionData?.convenienceFee}</Typography>
            </Box><Box sx={{p:'1% 2%',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                <Typography sx={{fontSize:'0.75rem',fontWeight:600,color:'#181818'}}>Taxes</Typography>
                <Typography sx={{fontSize:'0.75rem',fontWeight:500,color:'#181818'}}>₹ {descriptionData?.totalTax}</Typography>
            </Box>
            <Box sx={{p:'1% 2%',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                <Typography sx={{fontSize:'0.75rem',fontWeight:600,color:'#181818'}}>TCS (1% on ₹{descriptionData?.taxableAmount})</Typography>
                <Typography sx={{fontSize:'0.75rem',fontWeight:500,color:'#181818'}}>₹ {descriptionData?.tcsAmount || `0.00`}</Typography>
            </Box>
            <Box sx={{p:'1% 2%',display:'flex',justifyContent:'space-between',alignItems:'center',borderTop:'1px solid lightGray'}}>
                <Typography sx={{fontSize:'0.75rem',fontWeight:600,color:'#d32f2f'}}>Balance Amount</Typography>
                <Typography sx={{fontSize:'0.75rem',fontWeight:500,color:'#d32f2f'}}>₹ {descriptionData?.cudelBalance}</Typography>
            </Box>
        </Card>
    </Box>
  )
}

export default PaymentDescription